import FlatIcon from '../../../icons/flat.svg'

export const FLAT_SEARCH_ITEM_ICON = { Icon: FlatIcon }
